// @flow strict
import React from 'react';
import {Link as RouterLink} from 'react-router';

type Props = {
  to:string,
  children:React$Node,
  external?:boolean,
  className?:string,
  onClick?:() => void,
};

const Link = (props:Props) => {
  const {to, external, children, className, onClick} = props;
  function handleClick() {
    if (onClick) onClick();
  }
  // Need to disable eslint here because if you don't
  // use Boolean cast, you get a sketchy-null-bool
  // linter error. Consider refactor.
  // eslint-disable-next-line no-extra-boolean-cast
  if (Boolean(external)) {
    return (
      <a href={to} className={className} onClick={handleClick}>
        {children}
      </a>
    );
  }
  return (
    <RouterLink to={to} className={className} onClick={handleClick}>
      {children}
    </RouterLink>
  );
};

export default Link;
